import { Avatar, ChakraFlex, CircularProgress, Text } from '@equip.health/ui';
import { DateTime } from 'luxon';
import ProviderAvatarTooltipWrapper from '~/components/common/ProviderAvatarBlockTooltipWrapper';

interface ProviderAvatarWithDateProps {
  firstName: string;
  lastName: string;
  signedAt: string;
  avatarUrl?: string;
  isLoading?: boolean;
  isHide?: boolean;
  providerExternalId: string;
}

const ProviderAvatarWithDate = ({
  firstName,
  lastName,
  signedAt,
  avatarUrl,
  isLoading,
  isHide,
  providerExternalId,
}: ProviderAvatarWithDateProps) => {
  if (isLoading) {
    return (
      <CircularProgress
        aria-label="provider-avatar-with-date-progress-indicator"
        id="provider-avatar-with-date"
        isIndeterminate
        size="20px"
      />
    );
  }

  if (isHide) {
    return null;
  }

  return (
    <ProviderAvatarTooltipWrapper
      isRoleAtAction
      placement="top"
      providerExternalId={providerExternalId}
    >
      <ChakraFlex alignItems="center" gap="6px" padding="6px 8px">
        <Avatar
          aria-label="discharge-plan-signed-by-provider__avatar"
          id="discharge-plan-signed-by-provider"
          name={`${firstName} ${lastName}`}
          size="2xs"
          src={avatarUrl}
          textSize="xs"
          userType="provider"
        />
        <Text
          aria-label="discharge-plan-signed-by-provider__text"
          color="neutral.secondary"
          variant="caption"
        >
          {firstName} {lastName} on{' '}
          {signedAt
            ? DateTime.fromISO(signedAt).toFormat("MM/dd/yyyy 'at' h:mma")
            : ''}
        </Text>
      </ChakraFlex>
    </ProviderAvatarTooltipWrapper>
  );
};

export default ProviderAvatarWithDate;
